const CustomOption = (props) => {
    const { data, isSelected, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "10px" }}>
        <input type="checkbox" checked={isSelected} readOnly style={{ marginRight: "10px" }} />
        {data.label}
      </div>
    );
  };

  export default CustomOption;